import React from 'react';
import {styled} from '@mui/material/styles';

const HelpSvg = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38.476"
    height="34.239"
    viewBox="0 0 38.476 34.239"
    {...props}
  >
    <g
      id="Group_4512"
      data-name="Group 4512"
      transform="translate(-4454.143 14244.31)"
    >
      <rect
        id="Rectangle_1907"
        data-name="Rectangle 1907"
        width="4.002"
        height="1.61"
        transform="translate(4487.812 -14240.224)"
      />
      <rect
        id="Rectangle_1908"
        data-name="Rectangle 1908"
        width="4.002"
        height="1.61"
        transform="translate(4487.812 -14237.671)"
      />
      <path
        id="Path_30085"
        data-name="Path 30085"
        d="M646.415,42.439l-2.805-7.2V9.9a1.638,1.638,0,0,1,1.636-1.637h2.34A1.638,1.638,0,0,1,649.222,9.9V35.242Zm-1.2-7.5,1.2,3.067,1.2-3.067V9.9l-2.366-.027Z"
        transform="translate(3843.397 -14252.57)"
      />
      <rect
        id="Rectangle_1909"
        data-name="Rectangle 1909"
        width="4.002"
        height="1.61"
        transform="translate(4487.812 -14218.284)"
      />
      <path
        id="Path_30086"
        data-name="Path 30086"
        d="M625.556,36.129H602.785V8.261h22.771ZM604.4,34.519h19.551V9.871H604.4Z"
        transform="translate(3851.357 -14252.57)"
      />
      <path
        id="Path_30087"
        data-name="Path 30087"
        d="M633.865,45.672H611.951V41.151h1.61v2.912h18.695V26.142H629.18v-1.61h4.685Z"
        transform="translate(3849.57 -14255.743)"
      />
      <g
        id="Icon_ionic-md-help-circle-outline"
        data-name="Icon ionic-md-help-circle-outline"
        transform="translate(4459.167 -14237.571)"
      >
        <path
          id="Path_30082"
          data-name="Path 30082"
          d="M9.735,4.659a5.074,5.074,0,1,1-3.59,1.486,5.055,5.055,0,0,1,3.59-1.486m0-1.284a6.36,6.36,0,1,0,6.36,6.36,6.359,6.359,0,0,0-6.36-6.36Z"
          transform="translate(-3.375 -3.375)"
        />
        <g
          id="Group_4507"
          data-name="Group 4507"
          transform="translate(3.816 2.538)"
        >
          <path
            id="Path_30083"
            data-name="Path 30083"
            d="M16.523,23.836h1.284V25.12H16.523Z"
            transform="translate(-14.621 -17.476)"
          />
          <path
            id="Path_30084"
            data-name="Path 30084"
            d="M15.33,14.929H14.058c0-2.049,1.908-1.9,1.908-3.174a1.278,1.278,0,0,0-1.272-1.275,1.29,1.29,0,0,0-1.272,1.269H12.15a2.544,2.544,0,0,1,5.088,0C17.238,13.342,15.33,13.522,15.33,14.929Z"
            transform="translate(-12.15 -9.211)"
          />
        </g>
      </g>
    </g>
  </svg>
);
const CssHelpSvg = styled(HelpSvg)(({theme}) => ({
  fill: theme.palette.text.secondary,
  height: 'auto',
  maxHeight: 'calc(1vh + 1.7vw)',
  width: ' 100%',
}));

export default CssHelpSvg;
